// extracted by mini-css-extract-plugin
var _1 = "Card-Qk0GQ";
var _2 = "CardMoreDepth-MGYnY";
var _3 = "NoHover-cC08z";
export { _1 as "Card", _2 as "CardMoreDepth", _3 as "NoHover" }
